import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Drug, PNDrug } from '@nrwl/rx-models';
import { environment } from '@nrwl/environment';

@Injectable({
  providedIn: 'root',
})
export class DrugService {
  constructor(private _http: HttpClient) {}

  public getDrugs(): Observable<Drug[]> {
    return this._http
      .get(environment.baseAPIUrl + 'drug/?all=true')
      .pipe(map((res: any) => res.results.map((item) => new Drug({ ...item, _source: 'drug' }))));
  }

  public getDrugsV3(): Observable<Drug[]> {
    return this._http
      .get(environment.baseAPIUrlv3 + 'drug/?limit=1000')
      .pipe(map((res: any) => res.results.map((item) => new Drug({ ...item, _source: 'drug' }))));
  }

  public getPNDrugs(): Observable<PNDrug[]> {
    return this._http
      .get(
        environment.baseAPIUrlMicro +
          'egress-proxy/pne/servicescharting?Page=1&Rows=1000&IsActive=true&legacyids=true',
      )
      .pipe(
        map((res: any) => {
          const services = Array.isArray(res) ? res : (res?.Data ?? res?.results ?? res?.data ?? []);

          return services.map((item) => new PNDrug({ ...item, _source: 'pn' }));
        }),
      );
  }

  public updateDrug(data: any): Observable<any> {
    return this._http.patch(environment.baseAPIUrlv3 + 'drug/' + data.id + '/', data);
    // .pipe(
    //     map((res: any) => res.results.map(item => new Drug(item)))
    // );
  }

  public createDrug(data: Drug): Observable<any> {
    return this._http.post(environment.baseAPIUrl + 'drug/', data);
    // .pipe(
    //     map((res: any) => res.results.map(item => new Drug(item)))
    // );
  }

  public deleteDrug(drugId: number): Observable<any> {
    return this._http.delete(environment.baseAPIUrlv3 + 'drug/' + drugId + '/');
  }

  public getDrugsProductTypes(): Observable<any[]> {
    return this._http.get(environment.baseAPIUrlv3 + 'drug_product_type/').pipe(
      map((res: any) => {
        return res.results.map((item) => ({ value: item.id, text: item.name }));
      }),
    );
  }

  public getDrugsManufacturer(): Observable<any[]> {
    return this._http.get(environment.baseAPIUrlv3 + 'drug_manufacturer/').pipe(
      map((res: any) => {
        return res.results.map((item) => ({ value: item.id, text: item.name }));
      }),
    );
  }
}
